<template>
    <div>
        <section v-if="cityCount" class="activity-ctn">
            <div class="touch-strip promotion-strip"  @click="goToCity">
                <a href="javascript:;">
                    <div class="content">
                        <h3>出发城市 {{departCityName}}</h3>
                        <span class="more" v-if="cityCount > 1">{{cityCount}}个城市可选</span>
                        <i class="arrow" v-if="cityCount > 1"></i>
                    </div>
                </a>
            </div>
        </section>
        <div class="depart-city-desc" v-if="realDepartCityList && realDepartCityList.length" @click="changeDepartCityTip"><span>团期报价已包含{{departCityName}}到{{realDepartCityNames}}的交通服务费<i class="icon-description"></i></span></div>
        <Popup :show="showDepartCity" title="预定须知">
            <div class="price-tip">1. 团期报价已包含{{departCityName}}到{{realDepartCityNames}}的交通服务费</div>
            <div class="price-tip">2. {{departCityName}}出发时间以客服通知为准，{{departCityName}}到{{realDepartCityNames}}的在途时间不计入成团出游期间</div>
            <div class="price-tip">3. 旅客从{{departCityName}}到{{realDepartCityNames}}，全程须自行注意人身及财产安全</div>
        </Popup>
    </div>
</template>

<script>
import Popup from '@/components/Popup';
export default {
    name: 'departCity',
    data() {
        return {
            showDepartCity: {isShow: false}
        }
    },
    props: {},
    computed: {
        baseInfo() {
            return (this.$store.state.detail && this.$store.state.detail.baseInfo) || {};
        },
        departCityName () {
            return this.$store.state.detail.departCityName
        },
        realDepartCityList () {
            return this.$store.state.detail.realDepartCityList
        },
        cityCount() {
            // 目的地参团 || 当地玩乐不显示出发城市
            if (this.$store.getters.createGroupType === 2 || [3, 4, 5, 6].includes(this.baseInfo.prdTmpId) || (7 === this.baseInfo.prdTmpId && ![109, 110, 111, 112].includes(this.baseInfo.catId))) {
                return 0;
            }
            return this.baseInfo.otherInfo && this.baseInfo.otherInfo.departCity && this.baseInfo.otherInfo.departCity.departCityNum || 0;
        },
        realDepartCityNames() {
            if (this.realDepartCityList && this.realDepartCityList.length) {
                return this.realDepartCityList.map(el => el.cityName).join('或');
            } else {
                return '';
            }
        }
    },
    methods: {
        changeDepartCityTip() {
            this.showDepartCity.isShow = true;
        },
        goToCity() {
            if (this.cityCount > 1) {
                this.$router.push({name: 'City', params: { id: this.$route.params.id }})
            }
        }
    },
    components: {
        Popup
    }
}
</script>
<style lang="scss">
    .depart-city-desc {
        height: 24px;
        margin-bottom: 9px;
        overflow: hidden;
        & > span {
            position: relative;
            display: inline-block;
            padding: 0 32px 0 12px;
            font-size: 12px;
            color: #999;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
        }
        i {
            position: absolute;
            right: 7px;
            line-height: 24px;
            font-size: 26px;
        }
    }
    .price-tip {
        padding: 15px 12px 30px 12px;
         font-size: 13px;
         color: #666666;
         line-height: 18px;
         position: relative;
    }
</style>



// WEBPACK FOOTER //
// DepartCity.vue